<!-- Main modal -->
<!-- Overlay for modal -->
@if (visible) {
  <div
    class="fixed inset-0 bg-black/[0.32] dark:bg-black/60 h-screen w-screen z-[60]"
  ></div>
}

<div class="flex h-full w-full">
  <!--data-modal-toggle="select-modal"-->
  <div
    [style.display]="visible ? 'flex' : 'none'"
    tabindex="-1"
    class="fixed inset-0 z-[70] flex justify-center items-center overflow-y-auto"
  >
    <!-- Modal content -->
    <div class="max-w-md bg-white rounded-2xl shadow-2xl dark:bg-gray-900">
      <!-- Modal header -->
      <div
        class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600"
      >
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          Contact Information
        </h3>
        <button
          type="button"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          (click)="closeModal()"
        >
          <svg
            class="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <!-- Modal body -->
      <div class="p-4 md:p-5">
        <p class="text-gray-500 dark:text-gray-300 mb-4">
          For assistance using the application, questions, or to request a field
          boundary modification, please contact Land IQ at the email below.
        </p>
        <ul class="space-y-4 mb-4">
          <li>
            <label
              for="job-1"
              class="cursor-auto inline-flex items-center justify-between w-full p-5 text-gray-900 bg-white border border-gray-200 rounded-lg dark:border-gray-500 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 dark:text-white dark:bg-gray-600"
            >
              <div class="block">
                <div
                  class="w-full text-lg font-semibold text-gray-700 dark:text-gray-300"
                >
                  Email: irrigationmanagement&#64;landiq.com
                </div>
              </div>
            </label>
          </li>
        </ul>
        <button
          class="text-white inline-flex w-full justify-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          (click)="closeModal()"
        >
          CONFIRM
        </button>
      </div>
    </div>
  </div>
</div>
